import { globalModel } from "../../global/GlobalModel";
import { ShellTopBar } from "../shell/ShellTopBar";
import CustomerOrdersPage from "../../customer_account/OrdersPage";

export default function PlatformOrdersPage(): JSX.Element {
  return (
    <CustomerOrdersPage
      scope="platform"
      fixedTopBar
      topBar={<ShellTopBar onLoginClick={() => globalModel.openLoginModal()} />}
    />
  );
}
